import { ReactElement } from 'react';
import { Card, CardActions, CardContent } from '@mui/material';
import { DEFAULT_EC2_ROUTES } from '@localstack/constants';
import { useAwsEffect, useRoutes } from '@localstack/services';
import { CreateEC2VPCRequest } from '@localstack/types';
import { PageTitle, ProgressButton, VPCForm } from '@localstack/ui';

import { NavTabs } from './components/NavTabs';
import { EC2Props } from './types';

export const VPCCreate = ({ Layout, clientOverrides, routes = DEFAULT_EC2_ROUTES }: EC2Props): ReactElement => {
  const { goto } = useRoutes();

  const { createVpc, isLoading } = useAwsEffect('EC2', ['createVpc'], {
    revalidate: ['describeVpcs'],
    clientOverrides,
  });

  const handleCreate = async (data: CreateEC2VPCRequest) => {
    const result = await createVpc(data);
    const vpcId = result?.Vpc?.VpcId;

    if (vpcId) {
      goto(routes.RESOURCES_EC2_VPC, { vpcId });
    }
  };

  return (
    <Layout
      documentTitle="EC2: Create VPC"
      tabs={<NavTabs routes={routes} />}
      title={
        <PageTitle
          title="Create VPC"
          breadcrumbs={[
            ['EC2', () => goto(routes.RESOURCES_EC2)],
            ['VPCs', () => goto(routes.RESOURCES_EC2_VPCS)],
            ['Create VPC', null],
          ]}
        />
      }
      actions={
        <ProgressButton color="primary" variant="outlined" type="submit" form="VPCCreate" loading={isLoading}>
          Submit
        </ProgressButton>
      }
    >
      <Card>
        <CardContent>
          <VPCForm formId="VPCCreate" onSubmit={handleCreate} loading={isLoading} />
        </CardContent>
        <CardActions>
          <ProgressButton color="primary" variant="contained" type="submit" form="VPCCreate" loading={isLoading}>
            Submit
          </ProgressButton>
        </CardActions>
      </Card>
    </Layout>
  );
};
